import React from 'react'
import { Link } from 'gatsby'

import './Footer.scss'

import Icon from '../assets/svg/header-logo.svg'

const Footer = () => (
  <footer className="footer">
    <Link to="/">
      <Icon className="logo" />
    </Link>
    <div className="footerright">
      <Link to="/impressum/">
        <p>Kontakt / Impressum</p>
      </Link>
      <Link to="/datenschutz/">
        <p>Datenschutz</p>
      </Link>
    </div>
  </footer>
)

export default Footer
